import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { color } }) => css`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 20;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: ${color.background.neutral.inverted};
      opacity: 0.65;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme: { color, spacing, border } }) => css`
    transition: 1s linear;
    position: relative;
    display: grid;
    grid-gap: ${spacing.km6};
    width: 22.5rem;
    max-width: 100%;
    background: ${color.background.neutral.default};
    padding: ${spacing.km6};
    border-radius: ${border.radius.default};
  `}
`;

export const CloseContent = styled.div`
  ${() => css`
    width: 100%;
    display: grid;
    justify-content: end;
  `}
`;
